import CustomObjectCell from './component'

export default CustomObjectCell
